import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ps20-shop-expert-mode-design',
  templateUrl: './expert-mode-design.component.html',
  styleUrls: ['./expert-mode-design.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExpertModeDesignComponent {}
